export interface LetterRequestCustomer_Review {
  id:number,
  title:String,
  username:String,
  dsc:String,
  persianDate:String,
  del:boolean,
  type:number,
  option:Array<string>,
}

export function Empty_LetterRequestCustomer_Review():LetterRequestCustomer_Review{
  return{
    id:0,
    title: '',
    username: '',
    dsc:'',
    persianDate:'',
    del:false,
    type: 0,
    option:[]
  }
}
